var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileguideColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FLAT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m48 24a24 24 0 0 0 -24 23.99994v416.00006h48v-416.00006a24 24 0 0 0 -24-23.99994z",
    fill: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48 440a24 24 0 0 0 -24 24 24 24 0 0 0 24 24h376v-48z",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72 40h416v400h-416z",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160 176v-40a32 32 0 0 0 -64 0h16a16 16 0 0 1 32 0v8h-20a28 28 0 0 0 0 56h8a27.89157 27.89157 0 0 0 18.80957-7.27618 23.92471 23.92471 0 0 0 17.19043 7.27618v-16a8.00917 8.00917 0 0 1 -8-8zm-28 8h-8a12 12 0 0 1 0-24h20v12a12.01375 12.01375 0 0 1 -12 12z",
    fill: "#31c292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232 80a7.99962 7.99962 0 0 0 -7.53369 5.30908l-40 112 15.06738 5.38184 12.38965-34.69092h40.15332l12.38965 34.69092 15.06738-5.38184-40-112a7.99962 7.99962 0 0 0 -7.53369-5.30908zm-14.3623 72 14.3623-40.21436 14.3623 40.21436z",
    fill: "#31c292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296 96h168v16h-168z",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296 128h40v16h-40z",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352 128h112v16h-112z",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296 160h88v16h-88z",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.402 277.088h79.196v101.823h-79.196z",
    fill: "#00a16c",
    transform: "matrix(.707 -.707 .707 .707 -173.352 237.49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 344 13.31281 19.96921a16 16 0 0 1 2.68719 8.8752v3.15559a16 16 0 0 1 -16 16 16 16 0 0 1 -16-16v-3.15561a16 16 0 0 1 2.68719-8.8752z",
    fill: "#338dbf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.71 263.49-8.62 31.6-7.37 27.01-15.44-4.2001 9.78-35.83984 6.21-22.78a15.27029 15.27029 0 0 0 -14.72-19.28006 15.327 15.327 0 0 0 -14.68 11.07l-7.22 25.28-23.3 23.29992 15.14-52.97992a31.38307 31.38307 0 0 1 30.06-22.67 31.27091 31.27091 0 0 1 30.16 39.49z",
    fill: "#70d6b1"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#bebebe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m384 320h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416 320h48v16h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384 352h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416 352h48v16h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384 384h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416 384h48v16h-48z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m392 232h72v64h-72z",
    fill: "#5ca4cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288 320h16v16h-16z",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 320h48v16h-48z",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288 352h16v16h-16z",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 352h48v16h-48z",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288 384h16v16h-16z",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 384h48v16h-48z",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296 232h72v64h-72z",
    fill: "#5ca4cc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileguideColored);
export default __webpack_public_path__ + "static/media/fileguide_colored.bc2e4a94dfac239778ad3a28e527dba8.svg";
export { ForwardRef as ReactComponent };